import { render } from "./App.vue?vue&type=template&id=dd3183c6"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=dd3183c6&lang=scss"

import exportComponent from "/Users/tt/Projects/JavaProjects/xiongmaohaixing/vue_h5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__